import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconCompleted,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type GetCompletedMetadata, type LibraryRestorationTask } from '~/store/tasks/types';

export type RestoreLibraryCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<LibraryRestorationTask>;
  onClear: () => void;
};

export const RestoreLibraryCompletedPanelItem = memo(
  ({ metadata: { title }, onClear }: RestoreLibraryCompletedPanelItemProps) => {
    return (
      <PaneItemTW
        truncate={false}
        avatar={<FileStatusIconCompleted />}
        title={<FileStatusTitle>Recovered successfully</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            <span className="flex-none pr-1">Recovered library: </span>
            <EllipsisInMiddle className="font-bold" text={title || ''} />
          </FileStatusSubtitle>
        }
        buttons={
          <FileStatusButton label="Clear" onClick={onClear}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

RestoreLibraryCompletedPanelItem.displayName = 'RestoreLibraryCompletedPanelItem';
